/**
 * Authentication utility functions
 */

/**
 * Get the authentication token from local storage
 * @returns {string|null} - The authentication token or null if not found
 */
export const getToken = () => {
  return localStorage.getItem('token');
};

/**
 * Check if the user is authenticated
 * @returns {boolean} - True if the user is authenticated, false otherwise
 */
export const isAuthenticated = () => {
  return !!getToken();
};

/**
 * Get the user data from local storage
 * @returns {Object|null} - The user data or null if not found
 */
export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

/**
 * Get the user permissions from local storage
 * @returns {Object|null} - The user permissions or null if not found
 */
export const getPermissions = () => {
  const permissionsStr = localStorage.getItem('permissions');
  return permissionsStr ? JSON.parse(permissionsStr) : null;
};

/**
 * Clear all authentication data from local storage
 */
export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('permissions');
};
